import React from 'react';

const GlobalFooter: React.FC = () => {
  return (
    <footer className="bg-primary-900 border-t border-primary-700 px-4 md:px-6 py-3">
      <div className="flex items-center justify-between text-sm text-primary-300">
        <div>
          © {new Date().getFullYear()} Comex. All rights reserved.
        </div>
        <div className="flex items-center space-x-4">
          {/* Version or build info could go here */}
          <span className="hidden md:inline-block">
            v1.0.0
          </span>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;
